export const width = '290px';
export const dockSize = '80px';
export const type = 'Slide';
export const animate = false;
export const mediaQuery = '(min-width: 1200px)';
export const target = '.main-content';
export const enableDock = true;